import { Spin } from 'antd';

export function Loader({ tip }: { tip?: string }) {
  return (
    <div style={{ display: 'grid', placeItems: 'center', padding: 48 }}>
      <Spin tip={tip} />
    </div>
  );
}
